import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { DesktopAdSetupFactory } from 'tag/ts/tag/factories/ads/DesktopAdSetupFactory';
import { HTML5AdSetupFactory } from 'tag/ts/tag/factories/ads/HTML5AdSetupFactory';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class AdUtilities extends AbstractTagClass {
    #adSetupFactory;
    constructor(argument) {
        super({
            ...argument,
            name: 'AdUtilities'
        });
        this.#initAdSetupFactory();
    }
    paramsContainsAdContext = () => {
        return (this.utils.Type.isObject(this.params?.AD?.CONTEXT)
            &&
                !this.utils.Type.isEmpty(this.params?.AD?.CONTEXT));
    };
    getIMACustParams = () => {
        const siteSessionData = this?.tag?.model?.siteUtilities?.siteSessionData;
        if (this.utils.Type.isObject(siteSessionData)) {
            const cust_params = {};
            Object.keys(siteSessionData).forEach((key) => {
                const value = siteSessionData[key];
                switch (key) {
                    case 'vid':
                    case 'ppid':
                    case 'tfcd':
                        break;
                    default:
                        if (this.utils.Type.isEmpty(value) === false) {
                            cust_params[key] = value;
                        }
                }
            });
            if (this.utils.Type.isString(this?.params?.CONTEXT?.metadata?.userProfileCategory) &&
                !this.utils.Type.isEmpty(this?.params?.CONTEXT?.metadata?.userProfileCategory)) {
                cust_params.user =
                    this?.params?.CONTEXT?.metadata?.userProfileCategory;
            }
            return cust_params;
        }
    };
    adSetupInfo = () => {
        if (this.utils?.Type?.isEmpty(this.#adSetupFactory)) {
            this?.logger?.warn('adSetupInfo', 'adSetupFactory is empty, can not get adSetupInfo... exiting');
            return;
        }
        return this.#adSetupFactory.createAdSetupInfo();
    };
    formatAdParameter = (param = '') => {
        return param.replaceAll(' ', '_').toLowerCase();
    };
    #initAdSetupFactory = () => {
        if (this.utils.Type.isEmpty(this.params?.SYSTEM?.embedType)) {
            this?.logger?.warn('initAdSetupFactory', 'params.SYSTEM.embedType is empty, can not initialize adSetupFactory... exiting');
            return;
        }
        switch (this.params.SYSTEM.embedType) {
            case EmbedType.DESKTOP:
            case EmbedType.MOBILE_WEB:
                this.#adSetupFactory = new DesktopAdSetupFactory({ tag: this.tag });
                break;
            case EmbedType.HTML5:
                this.#adSetupFactory = new HTML5AdSetupFactory({ tag: this.tag });
                break;
            default:
                this?.logger?.warn('initAdSetupFactory', 'params.SYSTEM.embedType not supported:', this.params.SYSTEM.embedType);
                break;
        }
        this?.logger?.log('initAdSetupFactory', 'adSetupFactory:', this.#adSetupFactory);
    };
}
